import { css } from 'styled-components';

export const LightSkin = css`
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: none;
  border-radius: 20px;
`;

export const LightWrapperSkin = css`
  background: #f9f9f9;
`;

export const LightLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#000' : '#aaa')};
  opacity: ${props => (props.$isActive ? 1 : 0.2)};
`;
